.icon {
  width: 18px;
  height: 18px;
}
